module.exports = __webpack_public_path__ + "61fe0a7932b32dc641ff13fd2d96baa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PDF.jpg
// module id = 971
// module chunks = 0